
import { Component, Prop, Ref, Vue } from 'nuxt-property-decorator'
import { GameEvent } from './model/GameEvent'
import { WebPlayer } from '~/api'

@Component({})
export default class WebPlayerVideo extends Vue {
  @Prop() video!: GameEvent
  @Prop() platformSettings!: WebPlayer
  @Prop() isFullScreen!: boolean

  @Ref('video') media!: HTMLVideoElement

  get isControls(): boolean {
    return this.video.params.controls
  }

  get isAutoplay(): boolean {
    return this.video.params.autoplay
  }

  mounted() {
    this.media.addEventListener('ended', this.onVideoEnded)
  }

  beforeDestroy() {
    this.media.removeEventListener('ended', this.onVideoEnded)
  }

  onVideoEnded() {
    this.$emit('onVideoEnded')
  }
}
